import { Select } from 'antd';
import { t } from 'i18next';
import { observer } from 'mobx-react-lite';
import moment from 'moment';
import { useMemo, useState } from 'react';
import { Trans } from 'react-i18next';
import { Card } from 'src/components/Card/Card';
import { MerchantDto } from 'src/generated-api-client';
import { MerchantSalesTable } from 'src/pages/MerchantDetailsPage/components/MerchantSalesTable';

type MerchantSalesCardProps = {
    merchant?: MerchantDto;
};

export const MerchantSalesCard = observer(
    ({ merchant }: MerchantSalesCardProps) => {
        const [filterType, setFilterType] = useState<SalesType>(
            SalesType.MONTHLY,
        );

        const sales = merchant?.sales || [];

        const filteredSales = useMemo(() => {
            return sales
                .filter(
                    (sale) =>
                        sale.type?.toLowerCase() === filterType.toLowerCase(),
                )
                .sort((a, b) => {
                    if (!a.periodStart || !b.periodStart) {
                        return 0;
                    }

                    return (
                        moment(b.periodStart).valueOf() -
                        moment(a.periodStart).valueOf()
                    );
                });
        }, [sales, filterType]);

        return (
            <Card
                title={t('Merchant.Sales.Title')}
                extra={
                    <Select
                        value={filterType}
                        onChange={(value) => setFilterType(value as SalesType)}
                        options={salesTypeOptions}
                    />
                }
            >
                <MerchantSalesTable sales={filteredSales} />
            </Card>
        );
    },
);

export enum SalesType {
    MONTHLY = 'MONTHLY',
    WEEKLY = 'WEEKLY',
}

const salesTypeOptions = [
    {
        value: SalesType.MONTHLY,
        label: <Trans i18nKey="Merchant.Sales.Monthly" />,
    },
    {
        value: SalesType.WEEKLY,
        label: <Trans i18nKey="Merchant.Sales.Weekly" />,
    },
];
